/**
 * プランの条件を 1 行にまとめて出す
 *
 * 移動手段や上限時間はシートを開かないと分からなかったので、常に見えるところに置く。
 * 編集はシートヘッダーの「条件」ボタンから。
 */

import type { RoutePlanDetail } from '@/api/types/route-plan'
import { parseUtcDate } from '@/lib/date-utils'

import { formatDuration, toTimeInput } from '../../lib'

const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土']

const TRAVEL_LABEL: Record<string, string> = { driving: '車', walking: '徒歩' }

/** plan_date が空でも depart_at から日付を拾う */
const dateLabel = (plan: RoutePlanDetail): string | null => {
  const iso = plan.plan_date ?? plan.depart_at
  if (!iso) return null
  const date = plan.plan_date ? new Date(`${plan.plan_date}T00:00:00`) : parseUtcDate(iso)
  return `${date.getMonth() + 1}/${date.getDate()}(${WEEKDAYS[date.getDay()]})`
}

// 端点にスポットを充てると origin_name / dest_name は古いままなので、スポット名を優先する
const routeLabel = (plan: RoutePlanDetail): string => {
  const origin = plan.origin_item?.name ?? plan.origin_name ?? '出発地'
  if (plan.return_to_origin) return `${origin} → ${origin}`
  const dest = plan.dest_item?.name ?? plan.dest_name
  return dest ? `${origin} → ${dest}` : `${origin} → 到着地なし`
}

type Props = {
  plan: RoutePlanDetail
}

export const PlanConditionSummary = ({ plan }: Props) => {
  const parts = [
    [dateLabel(plan), plan.depart_at ? `${toTimeInput(plan.depart_at)} 出発` : null].filter(Boolean).join(' '),
    TRAVEL_LABEL[plan.travel_mode] ?? plan.travel_mode,
    routeLabel(plan),
    plan.max_duration_minutes ? `上限 ${formatDuration(plan.max_duration_minutes * 60)}` : null,
  ].filter((part): part is string => Boolean(part))

  return (
    <p className="border-b bg-muted/20 px-3 py-2 text-xs leading-relaxed text-muted-foreground">{parts.join(' ・ ')}</p>
  )
}
